import React from 'react';
import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';
import Select from 'components/shared/select';
import Selections from 'components/shared/AI/Selections';
import { useFeatureFlags } from 'components/shared/hooks';
import {
  GENERATED_QUESTION_TYPES,
  GENERATED_QUESTION_OPTIONS,
  questionTypeChoices,
  questionOptionChoices,
} from '../constants';

const QuestionOptions = ({
  selectedQuestionType,
  setSelectedQuestionType,
  selectedAIOption,
  setSelectedAIOption,
  questionText,
  setQuestionText,
}) => {
  const hasQuestionAssistantFreeResponse = useFeatureFlags([
    'learning-enable-question-assistant-free-response',
  ]);

  return (
    <div className="ElementAssistantModal-input">
      <Text
        variant={TEXT_VARIANTS.BODY_LIGHT}
        id="questionTypeLabel"
        className="mb-8"
        component="div"
      >
        {t('lessons.editor.element_assistant.question_types.label')}
      </Text>
      {hasQuestionAssistantFreeResponse && (
        <Select
          aria-labelledby="questionTypeLabel"
          value={selectedQuestionType}
          onChange={e => setSelectedQuestionType(e.target.value)}
          fullWidth
        >
          {questionTypeChoices.map(({ text, value }) => (
            <option key={value} value={value}>
              {text}
            </option>
          ))}
        </Select>
      )}
      {!hasQuestionAssistantFreeResponse && (
        <Selections
          aria-labelledby="questionTypeLabel"
          selections={questionTypeChoices.filter(
            type => type.value !== GENERATED_QUESTION_TYPES.FREE_RESPONSE,
          )}
          selection={selectedQuestionType}
          setSelection={setSelectedQuestionType}
        />
      )}
      {selectedQuestionType !== GENERATED_QUESTION_TYPES.FREE_RESPONSE && (
        <>
          <Text
            id="questionOptionsLabel"
            variant={TEXT_VARIANTS.BODY_LIGHT}
            className="mt-16 mb-8"
            component="div"
          >
            {t('lessons.editor.element_assistant.question_options.label')}
          </Text>
          <Selections
            aria-labelledby="questionOptionsLabel"
            selections={questionOptionChoices}
            selection={selectedAIOption}
            setSelection={setSelectedAIOption}
          />
        </>
      )}
      {selectedAIOption === GENERATED_QUESTION_OPTIONS.ANSWERS_ONLY && (
        <div className="ElementAssistantModal-questionInput mt-16">
          <Text variant={TEXT_VARIANTS.BODY_LIGHT} id="questionTextLabel">
            {t('lessons.editor.element_assistant.question_textbox.label')}
          </Text>
          <textarea
            aria-labelledby="questionTextLabel"
            className="ElementAssistantModal--textarea mt-8 NewInput NewInput--white NewInput--fw"
            rows="3"
            placeholder={t(
              'lessons.editor.element_assistant.question_textbox.placeholder_text',
            )}
            value={questionText}
            onChange={e => setQuestionText(e.target.value)}
          />
        </div>
      )}
    </div>
  );
};

export default QuestionOptions;
